export default {
  mounted () {
    const routeQuery = this.$route.query
    const routeKeyQuery = Object.keys(this.$route.query)
    if (routeKeyQuery.length) {
      routeKeyQuery.forEach(key => {
        if (Object.keys(this.additionalOptions).includes(key)) {
          this.additionalOptions[key] = routeQuery[key]
        }
      })
    }
    this.$refs?.newFilter && this.$refs.newFilter.search()
  }
}
